// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectTradeMessage } from '@shared/utils/DirectMessages/DirectMessagesImport';
import { ProductType } from '@shared/utils/Instruments/ProductType';
import { OperationType } from '@shared/utils/Trading/OperationType';
import { TradeSideEnum, TradeStatusEnum } from './TradeEnums';
/// <summary>
/// Объект для нового трейда
/// </summary>
export class NewTrade {
    constructor(cache, message) {
        this.Rebates = 0;
        /// <summary>
        /// Используется для начисления свопа не на баланс а на pnl (без необходимости не трогать)
        /// </summary>
        this.Swap = 0;
        this.TradeSide = TradeSideEnum.None;
        this.Instrument = null;
        this.Account = null;
        /// <summary>
        /// Признак того, что трейд получен по отчёту
        /// </summary>
        this.IsHistoryTrade = false;
        this.isBaseInstrument = false;
        this.boughtString = '';
        this.soldString = '';
        this.AdvancedTradeParams = null;
        this.ProductType = null;
        this.Description = null;
        this.Leverage = null;
        this.InstrumentStr = undefined;
        this.Bought = undefined;
        this.Sold = undefined;
        this.TradeVolume = undefined;
        this.TradingExchange = undefined;
        this.DataCache = cache;
        if (message) {
            this.UpdateByMessage(message);
        }
    }
    CreateTradeMessage() {
        const message = new DirectTradeMessage();
        message.TradeId = this.TradeId;
        message.OrderId = this.OrderId;
        message.Symbol = this.Symbol;
        message.AccountId = this.AccountId;
        message.Amount = this.Amount;
        message.Price = this.Price;
        message.Comission = this.Comission;
        message.Rebates = this.Rebates;
        message.PnL = this.PnL;
        message.Time = this.Time;
        message.BuySell = this.BuySell;
        message.ExternalPrice = this.ExternalPrice;
        // +++yura
        message.Exchange = this.Exchange;
        message.OrderType = this.OrderType;
        message.Login = this.Login;
        message.Route = this.RouteID;
        message.PositionID = this.PositionID;
        message.LastPositionAmount = this.LastPositionAmount;
        message.PositionSide = this.PositionSide;
        message.IsClosing = this.PositionSide === TradeStatusEnum.Close;
        message.CounterOrderID = this.CounterOrderID;
        message.OpenCrossPrise = this.OpenCrossPrise;
        message.ExternalTradeId = this.ExternalTradeId;
        message.ExternalOrderId = this.ExternalOrderId;
        message.ProductType = this.ProductType;
        message.InstrumentTradableID = this.InstrumentTradableID;
        message.ExecutionVenue = this.ExecutionVenue;
        message.Leverage = this.Leverage;
        return message;
    }
    UpdateByMessage(message) {
        var _a;
        this.TradeId = message.TradeId;
        if (!message.TradeIdLabel) {
            this.TradeIdLabel = message.TradeIdLabel;
        }
        this.OrderId = message.OrderId;
        this.Symbol = message.Symbol;
        this.AccountId = message.AccountId;
        this.Amount = message.Amount;
        this.Price = message.Price;
        this.Comission = message.Comission / message.OpenCrossPrise;
        this.Rebates = message.Rebates || this.Rebates || 0; // TODO найти rebates seter
        this.PnL = message.PnL;
        this.Time = message.Time;
        this.BuySell = message.BuySell;
        this.ExternalPrice = message.ExternalPrice;
        // if (message.ComissionInInstrumentQuotingCurrency.HasValue)
        //    this.ComissionInInstrumentQuotingCurrency = message.ComissionInInstrumentQuotingCurrency.Value;
        // if (message.PnLInInstrumentQuotingCurrency.HasValue)
        //    this.PnLInInstrumentQuotingCurrency = message.PnLInInstrumentQuotingCurrency.Value;
        // +++yura
        this.Exchange = message.Exchange;
        this.OrderType = message.OrderType;
        this.Login = message.Login;
        this.RouteID = message.Route;
        this.PositionID = message.PositionID;
        this.LastPositionAmount = message.LastPositionAmount;
        this.TradeSide = message.PositionSide;
        this.CounterOrderID = message.CounterOrderID;
        this.OpenCrossPrise = message.OpenCrossPrise;
        this.ExternalTradeId = message.ExternalTradeId;
        this.ExternalOrderId = message.ExternalOrderId;
        if (this.LastPositionAmount === 0) {
            this.PositionSide = TradeStatusEnum.Close;
        }
        else if ((this.BuySell === OperationType.Buy && this.TradeSide === TradeSideEnum.Long) || // buy
            (this.BuySell === OperationType.Sell && this.TradeSide === TradeSideEnum.Short)) {
            // sell
            if (this.LastPositionAmount === this.Amount) {
                this.PositionSide = TradeStatusEnum.Open;
            }
            else if (this.Amount > this.LastPositionAmount) {
                this.PositionSide = TradeStatusEnum.Reverce;
            }
            else {
                this.PositionSide = TradeStatusEnum.Increase;
            }
        }
        else {
            this.PositionSide = TradeStatusEnum.Decrease;
        }
        this.InstrumentTradableID = message.InstrumentTradableID;
        this.Instrument = this.DataCache.getInstrumentByTradable_ID(this.InstrumentTradableID, this.RouteID);
        if (this.Instrument) {
            this.Description = this.Instrument.DescriptionValue();
        }
        // if (!this.RouteID)
        //    this.Symbol = DataCache.GetFullName(this.Symbol, this.RouteID);
        if (this.AccountId != null) {
            this.Account = this.DataCache.GetAccountById(this.AccountId.toString());
        }
        this.Swap = message.Swap || this.Swap || 0; // TODO найти Swap seter
        this.AdvancedTradeParams = message.AdvancedTradeParams;
        this.ProductType = (_a = message.ProductType) !== null && _a !== void 0 ? _a : ProductType.General;
        this.ExecutionVenue = message.ExecutionVenue;
        this.Leverage = message.Leverage || null;
    }
    getTradeVolume() {
        if (isValidNumber(this.TradeVolume)) {
            return this.TradeVolume;
        }
        if (!isNullOrUndefined(this.Instrument)) {
            return this.Price * this.Amount * this.Instrument.LotSize * this.Instrument.GetFaceValueMultiplier();
        }
        else {
            return this.Price * this.Amount;
        }
    }
    getAmount() {
        return this.Amount;
    }
    // #region Misc
    Dispose() {
        this.Instrument = null;
        this.Account = null;
    }
}
